import axios from 'axios';
import authConfig from "../config/authConfig";

export default class TokenService {

    static urlToken = authConfig["url-request-authToken"]
    static urlTokenSaml = authConfig["url-request-samlToken"]
    static urlRefreshToken = authConfig["url-request-refreshToken"]


    static requestRefreshToken(sessioneUtente) {
        return axios.post(this.urlRefreshToken, {sessioneUtente: sessioneUtente}, {withCredentials: true});
    }

    static tokenAthn(authorizationCode, codeVerifier) {
        return axios.post(this.urlToken, {
            authorizationCode: authorizationCode,
            codeVerifier: codeVerifier
        }, {withCredentials: true});
    }

    static requestNewSamlToken(idSession) {
        return axios.post(this.urlTokenSaml, {sessionId: idSession}, {withCredentials: true});
    }
}
